import { mountSingleRace } from './utils/mount-single-race.js';

// Story-page version of the L.A. mayor race (s-mayor.js is the story stream one)
mountSingleRace('CA-84303', { embedName: 'results-CA-84303' }).catch(
  console.error
);
